<template>
  <button class="lang-toggle" @click="toggleLang" :title="otherLang.label">
    <img
      :src="require('../../assets/img/' + otherLang.icon)"
      :alt="otherLang.label"
    />
  </button>
</template>

<script>
const langs = {
  de: { alias: 'de', icon: 'flag_de.jpg', label: 'Deutsch' },
  en: { alias: 'en', icon: 'flag_en.jpg', label: 'English' },
};

export default {
  name: 'AppLangNav',
  computed: {
    otherLang() {
      return this.$i18n.locale === 'de' ? langs.en : langs.de;
    },
  },
  methods: {
    toggleLang() {
      this.$i18n.locale = this.otherLang.alias;
    },
  },
};
</script>

<style scoped lang="scss">
.lang-toggle {
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: 0.85;
  transition: opacity 150ms ease;

  &:hover {
    opacity: 1;
  }

  img {
    width: 28px;
    height: auto;
    display: block;
    border-radius: 2px;
  }
}
</style>
